import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://placeholder.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'placeholder';

const getProjectRef = (url: string): string => {
  try {
    return new URL(url).hostname.split('.')[0] || 'unknown';
  } catch {
    return 'unknown';
  }
};

export const AUTH_STORAGE_KEY = `sb-${getProjectRef(supabaseUrl)}-auth-token`;

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: AUTH_STORAGE_KEY,
    detectSessionInUrl: true,
    flowType: 'pkce',
    // Bypass navigator.locks which causes AbortError hangs in this PWA.
    // Safe because pwa-atkomst runs as a single-tab app.
    lock: async <R>(_name: string, _acquireTimeout: number, fn: () => Promise<R>): Promise<R> => {
      return await fn();
    },
  },
  global: {
    headers: {
      'x-client-info': 'pwa-atkomst',
    },
  },
});
